<template>
  <div class="common-container">
    <el-tabs tab-position="left" class="main-tabs">
      <el-tab-pane label="网址导航" style="overflow-x: auto;height: 850px;">
        <div class="nav-container">
          <websitesearch class="nav-item"/>
        </div>
        <div v-for="(item, index) in typeData" :key="index" class="nav-item">
          <webSiteInfo :tId="item.id.toString()" :tName="item.typeName"/>
        </div>
      </el-tab-pane>
      <el-tab-pane label="二维码">
        <qrcode/>
      </el-tab-pane>
      <el-tab-pane label="temp">
        <temp/>
      </el-tab-pane>
      <el-tab-pane label="base64">
        <base64/>
      </el-tab-pane>
      <el-tab-pane label="pinyin">
        <pinyin/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import webSiteInfo from '../view/websiteinfo'
import temp from '../view/temp'
import base64 from '../view/base64'
import pinyin from '../view/pinyin'
import qrcode from '../view/qrcode'
import websitesearch from '../view/websitesearch'
import {getWebsiteTypeList} from '../api/website'

export default {
  name: 'common',
  components: {
    webSiteInfo: webSiteInfo,
    temp: temp,
    qrcode: qrcode,
    websitesearch: websitesearch,
    base64: base64,
    pinyin: pinyin
  },
  data () {
    return {
      typeData: [],
      searchData: [],
      typeMap: new Map(),
      activeName: '',
      type: '',
      searchTitle: ''
    }
  },
  methods: {
    getWebsiteTypeList () {
      getWebsiteTypeList().then(response => {
        this.typeData = response.data
      })
    }
  },
  mounted () {
    this.getWebsiteTypeList()
  }
}
</script>

<style scoped>
.common-container {
  height: 100%;
}
.main-tabs {
  height: 100%;
}
.nav-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.nav-item {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/common.vue